import type { CompanionCommand, CropId, EnemyKind } from "./types";
export type Behavior =
  | "controlled"
  | "frozen"
  | "retreat"
  | "evade"
  | "gather"
  | "engage"
  | "guard"
  | "return"
  | "observe"
  | "rest";
export const AI_PROFILES: Record<
  CropId | EnemyKind,
  {
    perception: number;
    leash: number;
    idle: "observe" | "rest";
    personality: string;
  }
> = {
  pumpkin: {
    perception: 235,
    leash: 300,
    idle: "observe",
    personality: "勇敢护卫",
  },
  coconut: {
    perception: 210,
    leash: 280,
    idle: "rest",
    personality: "安稳补给",
  },
  wintermelon: {
    perception: 210,
    leash: 250,
    idle: "rest",
    personality: "沉稳坚守",
  },
  banana: {
    perception: 260,
    leash: 340,
    idle: "observe",
    personality: "好奇游侠",
  },
  moonherb: {
    perception: 220,
    leash: 280,
    idle: "observe",
    personality: "温和医官",
  },
  carrot: {
    perception: 310,
    leash: 380,
    idle: "observe",
    personality: "机敏斥候",
  },
  chili: {
    perception: 270,
    leash: 320,
    idle: "observe",
    personality: "急性术士",
  },
  mite: { perception: 480, leash: 570, idle: "observe", personality: "追猎" },
  brute: { perception: 420, leash: 500, idle: "rest", personality: "领地守护" },
  spitter: {
    perception: 480,
    leash: 550,
    idle: "observe",
    personality: "保持距离",
  },
  sentinel: {
    perception: 450,
    leash: 520,
    idle: "observe",
    personality: "固守阵地",
  },
  moth: { perception: 480, leash: 580, idle: "rest", personality: "优先支援" },
};
/** Declarative high-level priorities. Execution stays in World, without overwriting player commands. */
export function chooseBehavior(input: {
  controlled?: boolean;
  frozen?: boolean;
  command: CompanionCommand;
  danger?: boolean;
  enemy?: boolean;
  resource?: boolean;
  far?: boolean;
  idle?: "observe" | "rest";
}): Behavior {
  if (input.controlled) return "controlled";
  if (input.frozen) return "frozen";
  if (input.command === "retreat") return "retreat";
  if (input.danger) return "evade";
  if (input.command === "gather")
    return input.resource ? "gather" : (input.idle ?? "observe");
  if (input.enemy) return "engage";
  if (input.command === "guard") return "guard";
  if (input.far) return "return";
  return input.idle ?? "observe";
}
